(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-reviews"] && !Shopify.designMode) return;
  try {
    (function() {
  // ── Star picker ──────────────────────────────────────
  const picker = document.getElementById('nr-star-picker');
  const hidden = document.getElementById('nr-hidden-rating');
  const hint   = document.getElementById('nr-star-hint');
  const labels = ['','Terrible','Poor','Average','Good','Excellent'];
  if (picker) {
    const btns = picker.querySelectorAll('.nr__star-btn');
    function setActive(val) {
      btns.forEach((b, i) => {
        b.classList.toggle('active', i < val);
        b.style.color = i < val ? '#f5a623' : '';
      });
      if (hint) hint.textContent = val > 0 ? labels[val] + ' (' + val + '/5)' : 'Click to rate';
    }
    btns.forEach((btn, idx) => {
      btn.addEventListener('click', () => {
        hidden.value = idx + 1;
        setActive(idx + 1);
      });
      btn.addEventListener('mouseenter', () => {
        btns.forEach((b, i) => b.style.color = i <= idx ? '#f5a623' : '#ddd');
        if (hint) hint.textContent = labels[idx+1] + ' (' + (idx+1) + '/5)';
      });
    });
    picker.addEventListener('mouseleave', () => {
      const val = parseInt(hidden.value) || 0;
      setActive(val);
    });
  }

  // ── Form submit: prepend rating ──────────────────────
  const form = document.getElementById('nq-submit-form');
  if (form) {
    form.addEventListener('submit', e => {
      const rating = document.getElementById('nr-hidden-rating').value;
      if (!rating) { e.preventDefault(); alert('Please select a star rating.'); return; }
      const bodyField = document.getElementById('nr-body');
      bodyField.value = '[Rating: ' + rating + '/5]\n' + bodyField.value;
    });
  }

  // ── Animate bars on scroll ───────────────────────────
  const fills = document.querySelectorAll('.nr__bar-fill');
  if (fills.length) {
    const targets = Array.from(fills).map(el => ({ el, pct: el.dataset.pct }));
    // Reset to 0 width initially
    targets.forEach(t => t.el.style.width = '0');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            targets.forEach(t => t.el.style.width = t.pct + '%');
          }, 200);
          observer.disconnect();
        }
      });
    }, { threshold: 0.2 });
    const section = document.getElementById('reviews');
    if (section) observer.observe(section);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
